/* Different Drips — "Complete the look" v2 (snippets/dd-ctl2.liquid).
   Works across chain/bracelet pairs with different option setups:
   finish follows the chain when both have one, width is exact or the nearest
   the bracelet comes in, and the shopper only picks a wrist size. The box hides
   when the chain variant is itself a bracelet length (<12") or when the bracelet
   doesn't come in the chosen finish. When on, chain + bracelet are added in one
   request and Dawn's cart drawer opens; when off, Dawn's normal add runs. */
(function () {
  var WIDTH_RE = /^\s*\d+(\.\d+)?\s*mm\s*$/i;
  var SIZE_RE = /^\s*\d+(\.\d+)?\s*(inch|inches|in|")/i;
  var FIN_RE = /gold|tone|silver|black|rose|rainbow|platinum|blue|white|yellow|pink|purple/i;

  function money(cents) {
    var d = cents / 100;
    return '$' + (d % 1 ? d.toFixed(2) : String(d)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function num(v) { return parseFloat(String(v || '').replace(/[^\d.]/g, '')); }
  function finKey(v) { return String(v || '').toLowerCase().replace(/[^a-z]/g, ''); }
  function sizeLabel(v) { return String(v || '').replace(/\s*(inches|inch|in)\b/i, '"').trim(); }

  /* classify options by their values: finish / width / size(length) */
  function detect(product) {
    var res = { f: -1, w: -1, s: -1 };
    var n = (product.options || []).length;
    for (var i = 0; i < n; i++) {
      var vals = {};
      product.variants.forEach(function (v) { vals[v.o[i]] = 1; });
      var list = Object.keys(vals);
      var name = String(product.options[i] || '').toLowerCase();
      if (res.w < 0 && list.every(function (x) { return WIDTH_RE.test(x); })) res.w = i;
      else if (res.s < 0 && list.every(function (x) { return SIZE_RE.test(x); })) res.s = i;
      else if (res.f < 0 && (list.some(function (x) { return FIN_RE.test(x); }) || /colou?r|finish|type|metal|tone/.test(name))) res.f = i;
    }
    return res;
  }

  function init(root) {
    if (root.dataset.ddInit) return;
    root.dataset.ddInit = '1';

    var cfg = JSON.parse(root.querySelector('[data-dd-ctl2-config]').textContent);
    var sectionId = root.dataset.section;
    var formEl = document.getElementById('product-form-' + sectionId);
    if (!formEl) return;
    var productForm = formEl.closest('product-form');
    var idInput = formEl.querySelector('[name="id"]');

    var C = detect(cfg.chain);
    var B = detect(cfg.match);
    var chainById = {};
    cfg.chain.variants.forEach(function (v) { chainById[v.id] = v; });

    var toggle = root.querySelector('[data-dd-ctl2-toggle]');
    var thumb = root.querySelector('[data-dd-ctl2-thumb]');
    var thumbImg = root.querySelector('[data-dd-ctl2-img]');
    var sizesBox = root.querySelector('[data-dd-ctl2-sizes]');
    var el = function (k) { return root.querySelector('[data-dd-ctl2-' + k + ']'); };

    var chainFinishCount = C.f >= 0 ? Object.keys(cfg.chain.variants.reduce(function (a, v) { a[v.o[C.f]] = 1; return a; }, {})).length : 0;
    var chainWidthCount = C.w >= 0 ? Object.keys(cfg.chain.variants.reduce(function (a, v) { a[v.o[C.w]] = 1; return a; }, {})).length : 0;

    var state = { on: false, size: null };
    var current = null; /* { cv, mv, sizes:[{value, mv}] } */

    /* gallery card */
    var card = null;
    var viewer = document.getElementById('GalleryViewer-' + sectionId);
    if (viewer && thumbImg) {
      card = document.createElement('div');
      card.className = 'dd-ctl2-setcard';
      card.setAttribute('aria-hidden', 'true');
      card.innerHTML = '<div class="dd-ctl2-setcard__img"><img alt="" loading="eager"></div><span class="dd-ctl2-setcard__label">+ Matching bracelet</span>';
      viewer.appendChild(card);
    }

    function chainVariant() { return chainById[idInput && idInput.value] || null; }

    /* bracelet variants that fit the chosen chain variant, before picking a size */
    function fit(cv) {
      if (!cv) return null;
      if (C.s >= 0 && num(cv.o[C.s]) < 12) return null; /* chain variant is a bracelet length */
      var list = cfg.match.variants.slice();
      if (B.f >= 0) {
        if (C.f >= 0) {
          var want = finKey(cv.o[C.f]);
          list = list.filter(function (v) { return finKey(v.o[B.f]) === want; });
        } else {
          var firstFin = (list.find(function (v) { return v.a; }) || list[0] || { o: [] }).o[B.f];
          list = list.filter(function (v) { return v.o[B.f] === firstFin; });
        }
      }
      if (!list.length) return null;
      var width = null;
      if (B.w >= 0) {
        var widths = {};
        list.forEach(function (v) { widths[v.o[B.w]] = 1; });
        var opts = Object.keys(widths);
        if (C.w >= 0 && opts.length > 1) {
          var target = num(cv.o[C.w]);
          opts.sort(function (a, b) { return Math.abs(num(a) - target) - Math.abs(num(b) - target) || num(b) - num(a); });
        }
        width = opts[0];
        list = list.filter(function (v) { return v.o[B.w] === width; });
      }
      return { list: list, width: width };
    }

    function pickSize(sizes) {
      var avail = sizes.filter(function (s) { return s.mv && s.mv.a; });
      if (!avail.length) return null;
      if (state.size && avail.some(function (s) { return s.value === state.size; })) return state.size;
      var best = avail.slice().sort(function (a, b) { return Math.abs(num(a.value) - 8) - Math.abs(num(b.value) - 8) || num(b.value) - num(a.value); })[0];
      return best.value;
    }

    function shine() {
      thumb.classList.remove('is-shine');
      void thumb.offsetWidth;
      thumb.classList.add('is-shine');
    }

    var lastKey = '';
    var sizesKey = '';
    function render() {
      var cv = chainVariant();
      var f = fit(cv);
      var sizes = [];
      if (f) {
        if (B.s >= 0) {
          var seen = {};
          f.list.forEach(function (v) { if (!seen[v.o[B.s]]) seen[v.o[B.s]] = v; });
          var order = cfg.match.variants.map(function (v) { return v.o[B.s]; }).filter(function (v, i, a) { return a.indexOf(v) === i; });
          sizes = order.filter(function (s) { return seen[s]; }).map(function (s) { return { value: s, mv: seen[s] }; });
        } else {
          var only = f.list.find(function (v) { return v.a; });
          if (only) sizes = [{ value: '', mv: only }];
        }
      }
      var chosen = sizes.length ? pickSize(sizes) : null;
      var mv = null;
      sizes.forEach(function (s) { if (s.value === chosen) mv = s.mv; });

      var show = !!(cv && mv && mv.a);
      root.hidden = !show;
      if (!show) {
        if (state.on) setOn(false, true);
        current = null;
        return;
      }
      state.size = chosen;
      current = { cv: cv, mv: mv };

      /* wrist size buttons (rebuild only when the list changes) */
      var key = sizes.map(function (s) { return s.value + (s.mv.a ? '' : '!'); }).join('|');
      if (key !== sizesKey) {
        sizesKey = key;
        sizesBox.innerHTML = '';
        sizes.forEach(function (s) {
          if (!s.value) return;
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'dd-ctl2__size';
          b.setAttribute('role', 'radio');
          b.dataset.value = s.value;
          b.textContent = sizeLabel(s.value);
          b.disabled = !s.mv.a;
          sizesBox.appendChild(b);
        });
        var has8 = sizes.some(function (s) { return num(s.value) === 8; });
        el('hint').textContent = has8 ? 'Most men wear 8". Measure your wrist and add about 1".' : 'Measure your wrist and add about 1".';
      }
      sizesBox.querySelectorAll('.dd-ctl2__size').forEach(function (b) {
        b.setAttribute('aria-checked', b.dataset.value === chosen ? 'true' : 'false');
      });
      sizesBox.parentElement.querySelector('.dd-ctl2__legend--row').hidden = !sizes[0].value;
      sizesBox.hidden = !sizes[0].value;

      var bFinish = B.f >= 0 ? mv.o[B.f] : '';
      var bWidth = B.w >= 0 ? mv.o[B.w] : '';
      var img = mv.img || cfg.match.img;
      if (img && thumbImg.getAttribute('src') !== img) thumbImg.src = img;
      if (card) {
        var ci = card.querySelector('img');
        if (img && ci.getAttribute('src') !== img) ci.src = img;
      }

      var spec = [bWidth, bFinish].filter(Boolean);
      if (state.on && chosen) spec.push(sizeLabel(chosen));
      if (!spec.length) spec.push('Matching bracelet');
      el('spec').textContent = spec.join(' · ');

      el('now').textContent = '+' + money(mv.p);
      el('was').textContent = mv.c > mv.p ? money(mv.c) : '';
      var total = cv.p + mv.p;
      var totalWas = (cv.c > cv.p ? cv.c : cv.p) + (mv.c > mv.p ? mv.c : mv.p);
      el('total-now').textContent = money(total);
      el('total-was').textContent = totalWas > total ? money(totalWas) : '';
      el('total-save').textContent = totalWas > total ? 'You save ' + money(totalWas - total) : '';

      var sameW = C.w >= 0 && B.w >= 0 && num(cv.o[C.w]) === num(bWidth);
      var finOK = C.f >= 0 && B.f >= 0;
      var msg;
      if (sameW && finOK) msg = 'Same <b>' + bWidth + '</b> width, same <b>' + bFinish + '</b> finish as your chain.';
      else if (finOK) msg = 'Same <b>' + bFinish + '</b> finish as your chain' + (bWidth ? ', in a <b>' + bWidth + '</b> bracelet.' : '.');
      else if (sameW) msg = 'Same <b>' + bWidth + '</b> width as your chain.';
      else msg = 'The matching bracelet for this chain.';
      if ((finOK && chainFinishCount > 1) || (B.w >= 0 && chainWidthCount > 1)) msg += ' Change the chain and the bracelet follows.';
      el('matched').innerHTML = msg;

      var k = bFinish + '|' + bWidth;
      if (state.on && lastKey && k !== lastKey) shine();
      lastKey = k;
    }

    function setOn(on, silent) {
      state.on = on;
      root.classList.toggle('is-on', on);
      if (card) card.classList.toggle('is-on', on);
      toggle.setAttribute('aria-checked', on ? 'true' : 'false');
      if (on && !silent) shine();
      if (!silent) render();
    }

    toggle.addEventListener('click', function () { setOn(!state.on); });
    sizesBox.addEventListener('click', function (e) {
      var b = e.target.closest('.dd-ctl2__size');
      if (!b || b.disabled) return;
      state.size = b.dataset.value;
      render();
    });

    if (idInput) idInput.addEventListener('change', render);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
        if (e && e.data && e.data.sectionId === sectionId) setTimeout(render, 0);
      });
    }

    /* add both lines when the toggle is on; runs before Dawn's submit handler */
    if (productForm) {
      productForm.addEventListener('submit', function (evt) {
        if (!state.on || evt.target !== formEl || root.hidden || !current) return;
        var mv = current.mv;
        if (!mv || !mv.a) return; /* fall back to Dawn: chain only */

        evt.preventDefault();
        evt.stopImmediatePropagation();
        evt.stopPropagation();

        var btn = productForm.submitButton || formEl.querySelector('[type="submit"]');
        if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
        if (productForm.handleErrorMessage) productForm.handleErrorMessage();
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');
        var spinner = productForm.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        var fd = new FormData(formEl);
        var qty = parseInt(fd.get('quantity'), 10) || 1;
        var props = {};
        fd.forEach(function (val, key) {
          var m = key.match(/^properties\[(.+)\]$/);
          if (m && typeof val === 'string') props[m[1]] = val;
        });
        var chainId = parseInt(fd.get('id'), 10);
        var items = [
          { id: chainId, quantity: qty, properties: props },
          { id: mv.id, quantity: qty, properties: { _dd_set: 'Complete the look' } }
        ];

        var drawer = document.querySelector('cart-drawer');
        var body = { items: items };
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
          if (drawer.setActiveElement) drawer.setActiveElement(document.activeElement);
        }

        fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) {
              if (productForm.handleErrorMessage) productForm.handleErrorMessage(res.description || res.message);
              return;
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: chainId, cartData: res });
            }
            if (drawer && res.sections) {
              drawer.classList.remove('is-empty');
              drawer.renderContents(res);
            } else {
              window.location = window.routes.cart_url;
            }
          })
          .catch(function (e) { console.error(e); })
          .finally(function () {
            btn.classList.remove('loading');
            btn.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
          });
      }, true);
    }

    render();
  }

  function boot() {
    document.querySelectorAll('[data-dd-ctl2]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
